import Filters from "DashboardUser/components/Filters"
import { useAct } from 'DashboardUser/store'
import RecordModal from 'DashboardUser/components/RecordModal';
import DashboardTargetCard from "./DashboardTargetCard";

export default function DashboardTargetCards({ preview = false }) {
  const act = useAct();
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);
  const scrollRef = useRef(null);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 5;
    setShowScrollIndicator(el.scrollHeight > el.clientHeight && !isAtBottom);
  };

  // Getting data from your state management
  const dashboardTargets = useSel(s => _.orderBy(s.dashboardTargets.ids.map(id => s.dashboardTargets.entities[id]), '_position'));
  const { currentPage, totalPages, expandedDashboardTargetId } = useSel(s => s.local);
  const dashboardFields = useSel(s => _.orderBy(s.dashboard.dashboardFields, 'digitOrder', 'asc'));
  const dataLoading = useSel(s => s.local.dataLoading);

  const targetCount = dashboardTargets.length;

  useEffect(() => {
    handleScroll();
    window.addEventListener('resize', handleScroll);
    return () => window.removeEventListener('resize', handleScroll);
  }, [targetCount, currentPage]);

  // Pagination
  const handlePageChange = (page) => {
    page = Math.max(0, Math.min(page, totalPages));
    act.local.upsert({ currentPage: page });
  }

  return (
    <>
      <div className="team-table-container box">
        {dataLoading && <div className="table-loading-bar" />}
        {!preview && <>
          <div>
            <Filters />
          </div>
        </>}
        <div className="table-scroll-wrapper">
          <div className={`table-scroll-area custom-scrollbar ${dataLoading ? 'table-loading' : ''}`} ref={scrollRef} onScroll={handleScroll}>
            <div className="dashboard-card-view">
              {dashboardTargets.map(target => (
                <DashboardTargetCard key={target.id} dashboardTargetId={target.id} />
              ))}
            </div>
            {showScrollIndicator && (
              <div className="scroll-down-indicator">
                <span>Scroll for more ↓</span>
              </div>
            )}
          </div>
        </div>
        {dashboardTargets.length === 0 && <div className='no-data'>No members found with current filters.</div>}
        {dashboardTargets.length > 0 && !preview && <div className="team-table-footer">
          <div className="pagination">
            <button className='button pagination-prev' onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
              <SvgIconsBackCaret />
            </button>
            <div className="pagination-pages">
              <input type="text" className='pagination-current' value={currentPage} onChange={e => handlePageChange(Number(e.target.value))} />
              <span className='pagination-text'>of</span>
              <span className='pagination-total'>{totalPages}</span>
            </div>
            <button className='button pagination-next' onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
              <SvgIconsForwardCaret />
            </button>
          </div>
        </div>}
      </div>
      {expandedDashboardTargetId && <RecordModal />}
    </>
  );
}
